import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from '../../core/services/auth.service';
import { ProfileService } from '../../core/services/profile.service';
import { ProfileInfo } from '../../core/models/profile-info';
import { firebase } from '@firebase/app';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
  providers: [AuthService,ProfileService]
})
export class RegistrationComponent implements OnInit {

  userForm: FormGroup;
  errorMessage:string[];
  isError :boolean = false;
  confirmMessage:string = null;

  imageFile :File = null;

  event :any;
  nameClass:string;
  emailClass:string;
  phoneClass:string;
  passClass:string;
  cPassClass:string;
  aboutClass:string;
  
  constructor(private router:Router,private route: ActivatedRoute, private authService: AuthService,private fb: FormBuilder,private profileService:ProfileService) { 
    this.userForm = fb.group({
        'name' : ['', Validators.compose([Validators.required, Validators.minLength(3)])],
        'email' : ['', Validators.compose([Validators.required, Validators.email])],
        'phoneNo' : ['', Validators.compose([Validators.required])],
        'about' : ['', Validators.compose([])],
        'password' : ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        'confirmPassword' : ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        'isProfileImageVisible' : [false],
        'isPhoneNumberVisible':[false]
        }, 
      {
        validator: this.matchPassword // your validation method
      });
      this.clearClasses();
  }
  
  matchPassword(AC: AbstractControl) {
    let password = AC.get('password').value; // to get value in input tag
    let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
     if(password != confirmPassword) {
         AC.get('confirmPassword').setErrors( {MatchPassword: true} )
     }else {
         return null
     }
 }

  ngOnInit() {
    
  }

  onBasicUpload(event){
    this.imageFile = event.files[0];
    this.userForm.patchValue({
      isProfileImageVisible :true
    });
  }
  
  deleteProfileImage(){
    console.log("delete");
    this.imageFile = null;
    this.userForm.patchValue({
      isProfileImageVisible :false
    });
  }

  submit(data){
    this.confirmMessage = null;
    this.isError = false;
    this.errorMessage = new Array();
    this.clearClasses();
    if(this.userForm.valid){
      this.authService.registerUser(data.email,data.password).then(value => {
        if(this.imageFile != null){
          let uploadTask = this.profileService.setProfileImage(this.imageFile,data.email);
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) =>  {this.confirmMessage = 'File Uploading...'},
            (error) => {
              this.errorMessage.push(error.message);
              this.isError = true;
            },
            () => {
              let profiledata = this.getProfileData(data);
              profiledata.profileImageUri = uploadTask.snapshot.downloadURL
              profiledata.updatedAt = new Date().getTime();
              profiledata.updatedAtImage = new Date().getTime();
              this.profileService.setUserProfile(profiledata).then(response=>{
                this.confirmMessage = 'User registered successfully';
                this.userForm.reset();
                this.imageFile = null;
              }).catch(error=>{
                this.errorMessage.push(error.message);
                this.isError = true;
              });
              setTimeout(function() {
                this.confirmMessage = null;
                this.router.navigate([Constants.LOGIN_URL]);
              }.bind(this), 1000);
            }
          );
        }else{
          let profiledata = this.getProfileData(data);
          profiledata.updatedAt = new Date().getTime();
          this.profileService.setUserProfile(profiledata).then(response=>{
            this.confirmMessage = 'User registered successfully';
            this.userForm.reset();
            this.imageFile = null;
          }).catch(error=>{
            this.errorMessage.push(error.message);
            this.isError = true;
          });
          setTimeout(function() {
            this.confirmMessage = null;
            this.router.navigate([Constants.LOGIN_URL]);
          }.bind(this), 1000);
        }
        
      }).catch(err => {
          this.errorMessage.push(err.message);
          this.isError = true;
          console.log('Something went wrong:',err.message);
      }); 
    }
    else{
      this.isError = true;
      this.validator();
    }
  }

  getProfileData(data):ProfileInfo{
    let profile = new ProfileInfo();
    profile.name = data.name;
    profile.email = data.email;
    profile.isPhoneNumberVisible = data.isPhoneNumberVisible;
    profile.isProfileImageVisible = data.isProfileImageVisible;
    profile.phoneNo = data.phoneNo;
    profile.about = data.about;
    
    return profile;
  }

  validator(){
    if(!this.userForm.get('email').valid){
      this.errorMessage.push('Email is not valid');
      this.emailClass = "form-control fieldWithErrors";
    }
    if(!this.userForm.get('name').valid){
      this.errorMessage.push('Name should have least 3 characters');
      this.nameClass = "form-control fieldWithErrors";
    }
    if(!this.userForm.get('phoneNo').value.match('[6-9]{2}[0-9]{8}')) {
      this.errorMessage.push('Phone Number is not valid');
      this.phoneClass = "form-control fieldWithErrors";
    }
    if(!this.userForm.get('password').valid){
      this.errorMessage.push('Password should have least 6 characters');
      this.passClass = "form-control fieldWithErrors";
    }
    if(!this.userForm.get('confirmPassword').valid){
      this.errorMessage.push('Confirm Password should match with password');
      this.cPassClass = "form-control fieldWithErrors";
    }
  }
  clearClasses(){
    this.nameClass = 'form-control';
    this.emailClass = 'form-control';
    this.phoneClass = 'form-control';
    this.passClass = 'form-control';
    this.cPassClass = 'form-control';
    this.aboutClass = 'form-control';
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/user/registration/registration.component.ts